import { UUID } from 'v2/core/entities/uuid';

export const isSavedSearch = (id?: UUID) => {
  return Boolean(id && id !== '');
};
